import { JwtPayload } from 'jwt-decode';

export interface ICountry {
  /** 国家所属洲 */
  continentName: string;
  /** 国家名字 */
  name: string;
  /** 国家code */
  countryCode: string;
  /** 语言 */
  language: string;
  /** 是否默认大区 */
  isGlobalDefault?: boolean;
  /**
   * 国家的来源（RES-3371）。'user' 表示用户在站点选择器里主动选定，随 countryInfo 一起持久化。
   * 用来把「主动切到 Global」和「没选过、默认落到 Global」区分开：前者登录后不该被账号国家顶掉，
   * 否则用户永远看不到 Global 站的选区引导（AC-6 / AC-21）。
   */
  source?: 'user';
}

/** 文件类型 */
export enum FileType {
  pdf = 'PDF',
  video = 'VIDEO',
  image = 'IMAGE',
  doc = 'DOC',
  excel = 'EXCEL',
  link = 'LINK',
  zip = 'ZIP',
}

/** 分页接口响应类型 */
export interface chengduPaginationResult<T> {
  /** 总页数 */
  pageCount?: number;
  /** 当前页 */
  pageIndex: number;
  /** 每页显示条数 */
  pageSize: number;
  /** 数据列表 */
  datas: T[];
  /** 总数 */
  total: number;
}

/** jwtToken字段类型定义 */
export interface ITokenItem extends JwtPayload {
  sdc: string | number;
  /** 用户id */
  user_id: string;
  /** 国家代码 */
  udc: number;
  /** 登录账号（通常为邮箱） */
  username?: string;
}

/** 产品资料、品牌资料和在线学院页面类型字段 */
export enum PageType {
  PRODUCTS = 'PRODUCTS',
  BRANDING = 'BRANDING',
  ACADEMY = 'ACADEMY',
}
